/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 8NbkXymcLwvMUC2yXeRrWk

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsbr2UhI7UlpvR } from "../fragment_icons/PlasmicGlobalVariant__Screen"; // plasmic-import: BR2UhI7ulpvR/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsbr2UhI7UlpvR
});
